// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ViewPropertiesReportComp from '../../components/Company/ViewPropertiesReport/ViewPropertiesReport';
// Type imports:
import { IAuthenticationWithIdAndEventId } from '../../types/CompanyTypes';

const ViewPropertiesReport: React.FC<IAuthenticationWithIdAndEventId> = ({
    id,
    eventId,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Fasteignir'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                subTitle='Fasteignir - Skýrsla'
                noAd
                component={
                    <ViewPropertiesReportComp
                        id={id ?? ''}
                        eventId={eventId ?? ''}
                    />
                } 
            />
        </Entrypoint>
    );
}

export default ViewPropertiesReport;